import Flickity from "flickity";

class HomeHero {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carousel = self.elem.querySelector('[data-carousel]');
        self.carouselItems = [...self.elem.querySelectorAll('[data-carousel-item]')];
        self.dots = [...self.elem.querySelectorAll('[data-dot]')];
    }

    init() {
        let self = this;

        self.initFlickity();
    }

    initFlickity() {
        let self = this;


        // Init Flickity
        const flkty = new Flickity( self.carousel, {
            autoPlay: 4000,
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            pauseAutoPlayOnHover: false,
            on: {
                ready: function() {
                    self.playSelectedCellVideo(this);
                }
            }
        });

        [...self.dots].map(dot => {
            // Get the slide number
            let cellNumber = parseInt(dot.getAttribute('data-slide'));

            dot.addEventListener('click', evt => {
                // Stop autoplay
                flkty.stopPlayer();
                // Select the slide
                flkty.select(cellNumber);
                // Restart autoplay (causes a timer reset)
                flkty.playPlayer();
            });
        });

        flkty.on( 'change', function(index) {

            // If this cell contains a video, reset the playhead and play it
            self.playSelectedCellVideo(flkty);

            // Get the corresponding dot
            let dot = self.dots.filter(dot => parseInt(dot.getAttribute('data-slide')) === index)[0];

            // Remove active class from all dots
            self.dots.map(dot => {
                dot.classList.remove('is-active');
            });

            // Add active class to dot for this slide
            dot.classList.add('is-active');
        });
    }

    playSelectedCellVideo(flkty) {
        let self = this;

        // Stop and reset all videos
        [...self.elem.querySelectorAll('video')].map(video => {
            video.pause();
            video.currentTime = 0;
        });

        // If the selected cell contains a video, reset the playhead and play it
        let video = flkty.selectedElement.querySelector('video');

        if(video && typeof(video.play) == "function") {
            video.play();
        }
    }
}

export default HomeHero;
